import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[maxVal]',
})
export class MaxInputValDirective {
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^\d*\d{0,2}$/);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-'];

  @Input('maxVal') maxVal: number;

  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && parseFloat(next) > this.maxVal) {
      event.preventDefault();
    }
  }
}
